import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  Box,
  LinearProgress,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const stepIcons = {
  0: <SolarPowerIcon fontSize="small" />,
  1: <LocationOnIcon fontSize="small" />,
  2: <UploadFileIcon fontSize="small" />,
  3: <CheckCircleIcon fontSize="small" />,
};

const StepIconComponent = (props) => {
  const { active, completed, icon } = props;
  return (
    <Box
      sx={{
        color: completed ? "success.main" : active ? "primary.main" : "grey.400",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {stepIcons[String(icon - 1)]}
    </Box>
  );
};

const RequestFormStepper = ({ activeStep, steps, stepShortLabels, isMobile }) => {
  const progress = ((activeStep + 1) / steps.length) * 100;

  if (isMobile) {
    return (
      <Box sx={{ mb: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ mb: 1 }}
        >
          <Typography variant="caption" color="text.secondary">
            مرحله {activeStep + 1} از {steps.length}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            {steps.map((_, index) => (
              <Box
                key={steps[index]}
                aria-hidden
                sx={{
                  width: index === activeStep ? 20 : 7,
                  height: 7,
                  borderRadius: 4,
                  bgcolor: index <= activeStep ? "primary.main" : "grey.300",
                  transition: "width 0.2s ease",
                }}
              />
            ))}
          </Stack>
        </Stack>

        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ height: 4, borderRadius: 2, mb: 1.5 }}
        />

        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              color: "primary.main",
              display: "flex",
              alignItems: "center",
              bgcolor: "grey.100",
              p: 0.75,
              borderRadius: 1.5,
            }}
          >
            {stepIcons[activeStep]}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              sx={{ fontSize: "0.9375rem", lineHeight: 1.35 }}
            >
              {steps[activeStep]}
            </Typography>
            {stepShortLabels?.[activeStep] ? (
              <Typography variant="caption" color="text.secondary">
                {stepShortLabels[activeStep]}
              </Typography>
            ) : null}
          </Box>
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIconComponent}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

RequestFormStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  stepShortLabels: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
};

export default RequestFormStepper;
